// 2026-10-02：完整清单先筛选再分页，保留原记录对象和导出数据，换查询或每页条数回到第一页。
import { computed, ref, watch } from 'vue'

export function useListPagination<T>(source: () => readonly T[]) {
  const current = ref(1)
  const pageSize = ref(30)
  const total = computed(() => source().length)
  watch(source, () => { current.value = 1 })
  watch(pageSize, () => { current.value = 1 }, { flush: 'sync' })
  watch(total, count => {
    current.value = Math.min(current.value, Math.max(1, Math.ceil(count / pageSize.value)))
  }, { flush: 'sync' })
  const rows = computed(() => source().slice((current.value - 1) * pageSize.value, current.value * pageSize.value))
  const change = (page: number, size: number) => {
    const resized = size !== pageSize.value
    pageSize.value = size
    current.value = resized ? 1 : page
  }
  return { current, pageSize, total, rows, change }
}
